import React from 'react'
import PropTypes from 'prop-types'
import querystring from 'querystring'
import { Link } from 'react-router-dom'
import './SearchHeader.css'
import logo from '../searchgull_logo.svg'

class SearchHeader extends React.Component {
  constructor() {
    super()
    this.state = {
      prevSearch: ''
    }
    this.syncSearchTerms = this.syncSearchTerms.bind(this)
  }
  componentWillMount() {
    this.syncSearchTerms()
  }
  componentWillUpdate() {
    this.syncSearchTerms()
  }
  componentWillUnmount() {
    this.setState({
      prevSearch: ''
    })
  }
  syncSearchTerms() {
    const urlSearch = querystring.parse(this.context.router.history.location.search)['?q']
    if (urlSearch !== this.state.prevSearch) {
      this.setState({
        prevSearch: urlSearch
      })
      if (urlSearch !== this.props.currSearch) {
        const target = { value: urlSearch}
        const event = {target}
        this.props.updateSearch(event)
      }
    }
  }
  getSearchTerm() {
    const urlSearchTerm = querystring.parse(this.context.router.route.location.search)['?q']
    if (!urlSearchTerm) {
      return ''
    }
    return urlSearchTerm
  }
  render() {
    //console.log(this.props);
    return (
      <div className="search-header">
        <div className="search-header-left">
          <Link to="/"><img src={logo} className="search-header-logo" alt="SearchGull" /></Link>
          <div className="searchbox">
            <form onSubmit={this.props.doSearch}>
              <input
                type="search"
                name="search"
                placeholder="Search..."
                value={this.props.currentSearch}
                className="searchbox-input"
                onChange={this.props.updateSearch}/>
            
              <button
                type="submit"
                className="searchbox-btn">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  version="1.1"
                  id="svg-search-icon"
                  viewBox="0 0 40 40"
                  height="16"
                  width="16">
                  <g
                    transform="translate(0,-1010)"
                    id="layer1">
                    <path
                      id="svg-search-path"
                      transform="translate(0,1012.3622)"
                      d="M 17.324219 0.048828125 A 17.147339 17.147339 0 0 0 0.17773438 17.195312 A 17.147339 17.147339 0 0 0 17.324219 34.34375 A 17.147339 17.147339 0 0 0 26.912109 31.404297 L 34.517578 39.009766 C 35.625578 40.117765 37.272915 40.254428 38.212891 39.314453 L 39.132812 38.394531 C 40.072788 37.454556 39.938078 35.805265 38.830078 34.697266 L 31.269531 27.136719 A 17.147339 17.147339 0 0 0 34.470703 17.195312 A 17.147339 17.147339 0 0 0 17.324219 0.048828125 z M 17.324219 6.5 A 10.694989 10.694989 0 0 1 28.019531 17.195312 A 10.694989 10.694989 0 0 1 17.324219 27.890625 A 10.694989 10.694989 0 0 1 6.6289062 17.195312 A 10.694989 10.694989 0 0 1 17.324219 6.5 z "
                        />
                  </g>
                </svg>
              </button>
            </form>
          </div>
        </div>
        <div className="search-header-right">
        <Link to="/settings">Settings</Link>
        <Link to="/about">About</Link>
        </div>
    </div>
    )
  }
}

SearchHeader.contextTypes = {
  router: PropTypes.object
}

export default SearchHeader;


// WEBPACK FOOTER //
// ./src/components/SearchHeader.js